import { omit } from 'lodash';
import { query, request } from 'src/utils/request';

const urls = {
  distributeList: '/zlb/api/expense/batch-distribute/query-page', // 查询批量发放列表接口
  distributeListForOperate: '/zlb/api/expense/batch-distribute/operation/query-page', // 运营侧查询批量发放
  commitExcel: '/zlb/api/expense/batch-distribute/import/submit', // 提交任务
  getCommitRes: '/zlb/api/expense/batch-distribute/import/get-result', // 解析任务
  distributeBaseInfo: '/zlb/api/expense/batch-distribute/query', // 查询批量发放基本信息
  deleteDistribute: '/zlb/api/expense/batch-distribute/delete', // 批量删除发放
  queryPayment: '/zlb/api/expense/batch-distribute/query-payment', // 支付信息查询
  queryDistributePage: '/zlb/api/expense/batch-distribute/detail/query-page', // 批量发放明细分页查询
  saveDistribute: '/zlb/api/expense/batch-distribute/save', // 保存批量发放基本信息
  batchDeleteDetail: '/zlb/api/expense/batch-distribute/detail/batch-delete', // 批量删除明细
  queryDetail: '/zlb/api/expense/batch-distribute/detail/query', // 查看发放明细基本信息
  queryError: '/zlb/api/expense/batch-distribute/detail/query-error', // 查看需要修改的code
  // distributePay: '/zlb/api/expense/batch-distribute/apply-pay', // 批量发放发起支付
  submit: '/zlb/api/expense/batch-distribute/submit', // 批量发放发起支付和提交
  updateBank: '/zlb/api/expense/batch-distribute/detail/update-bank', // 批量更新明细银行信息
  saveSingleDetail: '/zlb/api/expense/batch-distribute/detail/save', // 保存单个明细
  queryPayRes: '/zlb/api/expense/batch-distribute/batch/query-pay-result', // 批量发放结果
  getTemplate: '/zlb/api/expense/batch-distribute/import/get-template', // 获取下载模板
  deleteCheckUrl: '/zlb/api/expense/batch-distribute/detail/delete-check', // 删除校验
  disassembleDetail: '/zlb/api/expense/batch-distribute/detail/disassemble', // 拆分明细
};

/**
 * 查询批量发放列表接口
 * @param data
 * @returns
 */
export function distributeList(data) {
  return request(urls.distributeList, { method: 'POST', data });
}

/**
 * 运营侧查询批量发放列表接口
 * @param data
 * @returns
 */
export function distributeListForOperate(data) {
  return request(urls.distributeListForOperate, { method: 'POST', data });
}

/**
 * 提交任务
 * @param data
 * @returns
 */
export function commitExcel(data) {
  return request(urls.commitExcel, { method: 'POST', data });
}

/**
 * 解析任务
 * @param data
 * @returns
 */
export function getCommitRes(data) {
  return request(urls.getCommitRes, { method: 'POST', data });
}

/**
 * 区划单位表格数据
 */
export function districtInstitutionList(params) {
  return request('/zlb/operation/implement/institution/list', { method: 'get', params });
}

/**
 * 是否存在可用的工作流实例
 */
export function getExistUsableProcess(params) {
  return request('/zlb/api/mbp/workflow/biz/exist-usable-process', { method: 'get', params });
}

/**
 * 查询发放基本信息
 * @param params 发放唯一编号
 * @returns
 */
export function getDistributeBaseInfo(params) {
  return request(`${urls.distributeBaseInfo}/${params.batchDistributeCode}`, {
    method: 'get',
    params,
  });
}

/**
 * 删除批量发放
 * @param data ：发放编号Code
 * @returns
 */
export function deleteDistribute(params) {
  return request(`${urls.deleteDistribute}/${params.batchDistributeCode}`, { method: 'POST' });
}

/**
 * 查询支付信息
 * @param data ：支付明细入参
 * @returns
 */
export function queryPayment(data) {
  return request(urls.queryPayment, { method: 'POST', data });
}

/**
 * 查询发放明细
 * @param data ：发放明细分页查询
 * @returns
 */
export function queryDistributePage(data) {
  return request(urls.queryDistributePage, { method: 'POST', data });
}

/**
 * 保存批量发放基本信息
 * @param data
 * @returns
 */
export function saveDistribute(data) {
  return request(urls.saveDistribute, { method: 'POST', data });
}

/**
 * 批量删除明细
 * @param data
 * @returns
 */
export function batchDeleteDetail(data) {
  return request(urls.batchDeleteDetail, { method: 'POST', data });
}

/**
 * 查询明细基本信息
 * @param params 发放明细唯一编号
 * @returns
 */
export function queryDetail(params) {
  return request(`${urls.queryDetail}/${params.distributeDetailCode}`);
}

/**
 * 查询需要修改银行信息的明细
 * @param params 发放唯一编号
 * @returns
 */
export function queryError(params) {
  return request(`${urls.queryError}/${params.batchDistributeCode}`);
}

// /**
//  * 批量发放发起支付
//  * @param data 发起支付入参
//  * @returns
//  */
// export function distributePay (data) {
//   return request(urls.distributePay, { method: 'POST', data: omit(data, ['summary_without_code']) });
// }
export function submit(data) {
  return request(urls.submit, { method: 'POST', data: omit(data, ['summary_without_code']) });
}

/**
 * 批量更新银行信息
 * @param data 更新银行信息
 * @returns
 */
export function updateBank(data) {
  return request(urls.updateBank, { method: 'POST', data });
}

/**
 * 保存单个明细
 * @param data 保存明细
 * @returns
 */
export function saveSingleDetail(data) {
  return request(urls.saveSingleDetail, { method: 'POST', data });
}
/**
 * 查询批量发放支付结果
 * @param params 发放唯一编号
 * @returns
 */
export function queryPayRes(params) {
  return request(`${urls.queryPayRes}/${params.batchDistributeCode}`);
}
/**
 * 获取下载模板
 */
export function getTemplate(params) {
  return request(urls.getTemplate, { method: 'get', params });
}

/**
 * 删除校验
 */
export function deleteCheck(data) {
  return request(urls.deleteCheckUrl, { method: 'POST', data });
}

/**
 * 拆分明细
 */
export function disassembleDetail(data) {
  return request(urls.disassembleDetail, { method: 'POST', data });
}
// 加签
export function addTask(data) {
  return request('/zlb/api/expense/batch-distribute/workflow/add-task', {
    method: 'POST',
    data,
  });
}

// 作废申请单
export function reqApplyNullify(code) {
  return query(` /zlb/api/expense/apply-form/nullify/${code}`, {
    method: 'POST',
  });
}

// 通过驳回
export function batchDistributeAudit(data) {
  return request('/zlb/api/expense/batch-distribute/workflow/audit', {
    method: 'POST',
    data,
  });
}

// 撤回
export function stopWorkFlow(data) {
  return request('/zlb/api/expense/batch-distribute/workflow/revoke', {
    method: 'POST',
    data,
  });
}

// 校验明细---目前是校验是为了惠企利民
export function checkDetail(batchDistributeCode) {
  return query(`/zlb/api/expense/batch-distribute/check-detail/${batchDistributeCode}`, {});
}

// 查看明细（不分页
export function zlbApiExpenseBatchDistributeDetailQueryPost(data) {
  return query('/zlb/api/expense/batch-distribute/detail/query', {
    method: 'POST',
    data,
  });
}

// 申报单确认拆分
export function zlbApiExpenseBatchDistributeDeclarationDetailConfirmPost(data) {
  return query('/zlb/api/expense/batch-distribute/declaration-detail/confirm', {
    method: 'POST',
    data,
  });
}

// 选择申报单
export function zlbApiExpenseDeclarationSelectPost(data) {
  return query('/zlb/api/expense/declaration/select', {
    method: 'POST',
    data,
  });
}

// 查看指标关联的明细
export function zlbApiExpenseBatchDistributeBudgetDetailRelPagePost(data) {
  return query('/zlb/api/expense/batch-distribute/budget/detail-rel/page', {
    method: 'POST',
    data,
  });
}

// 明细自动拆分
export function zlbApiExpenseBatchDistributeDetailAutoDisassemblePost(data) {
  return query('/zlb/api/expense/batch-distribute/detail/auto-disassemble', {
    method: 'POST',
    data,
  });
}

// 兑付退款核销
export function zlbApiExpenseBatchDistributeDetailRefundCheck(data) {
  return query('/zlb/api/expense/batch-distribute/declaration-detail/refund-check', {
    method: 'POST',
    data,
  });
}

// 导出账户校验结果
export const exportBatchDistributeCheckResult = async data => {
  return query('/zlb/api/expense/batch-distribute/detail/check/export', { method: 'POST', data });
};

// 获取导出账户校验结果
export const getBatchDistributeCheckResult = async params => {
  return query('/zlb/api/expense/batch-distribute/detail/check/export/result', { params });
};
